import { createDecorator } from "../../instantiation/common/registry";
import { Event } from "../../../base/common/events.js";
import { MenuId } from "../../actions/common/actions";

export const IContextMenuService = createDecorator<IContextMenuService>('contextMenuService');

export interface ContextMenuContext {
    readonly menuId: MenuId;
    readonly targets: Array<unknown>;
    readonly textSelection?: string;
    readonly position?: { x: number, y: number };
}
export function isContextMenuContext (thing: any): thing is ContextMenuContext {
    return thing
        && typeof thing === 'object'
        && thing.menuId instanceof MenuId
        && Array.isArray(thing.targets);
}

export interface WillShowContextMenuArguments {
    readonly context: ContextMenuContext;
} 

export interface IContextMenuService {

    readonly _serviceBrand: undefined;
    
    readonly onWillShowContextMenu: Event<WillShowContextMenuArguments>;

    getContextMenuItems(context: ContextMenuContext): Array<IContextMenuItem | IContextMenuSubItem>;
}



export interface IContextMenuItem {
    readonly label: string;
    readonly icon: string | undefined;
    readonly tooltip?: string;
    readonly enabled?: boolean;
    readonly action: () => void;
}
export interface IContextMenuSubItem {
    readonly label: string;
    readonly icon: string | undefined;
    readonly subItems: Array<IContextMenuItem | IContextMenuSubItem>;
    readonly enabled?: boolean;
}

export function isContextMenuSubItem(item: IContextMenuItem | IContextMenuSubItem): item is IContextMenuSubItem {
    return (item as IContextMenuSubItem).subItems !== undefined;
}
export function isContextMenuItem(item: IContextMenuItem | IContextMenuSubItem): item is IContextMenuItem {
    return (item as IContextMenuItem).action !== undefined;
}